export default __webpack_public_path__ + "static/media/2412301.059fa68b.jpg";